import React, { useState } from 'react';
import { Button } from "components/UI/button/button";
import DownLoadArrow from 'components/icons/downloadArrow';
import styles from "./dashboardDocumentRow.module.scss";
import translations from 'locales';
interface IDashboardDocumentRow {
  index: number;
  docDesc: string;
  uploadedBy?: string;
  created: string;
  onRowClick?: () => void;
  onDownload?: (e: React.MouseEvent) => void;
}

export const DashboardDocumentRow = ({
  index,
  docDesc,
  uploadedBy,
  created,
  onRowClick = () => undefined,
  onDownload = () => undefined,
}: IDashboardDocumentRow) => {
  const [isDownloadingLocal, setIsDownloadingLocal] = useState(false);

  const handleDownload = async (e: React.MouseEvent) => {
    setIsDownloadingLocal(true);
    try {
      await onDownload(e);
    } finally {
      setIsDownloadingLocal(false);
    }
  };
  const lang = localStorage.getItem('lang') || 'en';

  return (
    <>
      <tr className={styles.selectableRow} onClick={onRowClick}>
        <td className={styles.textTitle}>{docDesc}</td>
        <td className={styles.headers}>{uploadedBy}</td>
        <td className={styles.headers}>{created}</td>
        <td>
          <Button
            id={"downloadDocument"}
            onClick={(e) => {
              e.stopPropagation();
              handleDownload(e);
            }}
            className={styles.viewDocument}
            mobileText={isDownloadingLocal ? lang === 'fr' ? translations.fr.downloading : translations.en.downloading : lang === 'fr' ? translations.fr.download : translations.en.download}
            disabled={isDownloadingLocal}
          >
            <div className={styles.buttonTitle}>
              {isDownloadingLocal ? lang === 'fr' ? translations.fr.downloading : translations.en.downloading : lang === 'fr' ? translations.fr.download : translations.en.download}
            </div>  
            {!isDownloadingLocal && <DownLoadArrow />}
          </Button>
        </td>
      </tr>
    </>
  );
};